// extracted by mini-css-extract-plugin
export default {"header":"Company_header__fZ9+Y","breadcrumbsWrapper":"Company_breadcrumbsWrapper__8Ir9P","actions":"Company_actions__Z4m4q"};